import Generate from './fake_generator'

function geoJSONString (type, coordinates, radius = null) {
  const object = {
    type: 'Feature',
    geometry: {
      type: type === 'Circle' ? 'Point' : type,
      coordinates,
    },
    properties: radius ? { radius } : {},
  }

  return JSON.stringify(object)
}

let lastPlantId = 20
const plants = {
  list: [],
  plant (mapId, plantId, plantationDate, geoJson, name = null) {
    const data = {
      id: lastPlantId++,
      mapId,
      plantId,
      name,
      plantationDate: plantationDate,
      geoJson,
    }
    this.list.push(data)
    return data
  },
  add (payload) {
    return this.plant(
      payload.mapId,
      payload.plantId,
      new Date(),
      payload.geoJson,
      (payload.name || null))
  },
  update (payload) {
    const plantIndex = this.list.findIndex(p => p.id === payload.id)
    if (plantIndex === -1) throw new Error(`Can't find plant #${payload.id} for update`)

    this.list[plantIndex].geoJson = payload.geoJson

    return this.list[plantIndex]
  },
}

plants.plant(1, 5, new Date(), geoJSONString('Point', [325, 422]))
plants.plant(1, 5, new Date(), geoJSONString('Point', [307, 472]))
plants.plant(1, 5, new Date(), geoJSONString('Point', [288, 542]))
plants.plant(1, 5, new Date(), geoJSONString('Point', [270, 628]))
plants.plant(1, 7, new Date(), geoJSONString('Circle', [450, 830], 30))
const polygonCoords = [[
  [387.9666147004976, 409.1387333457489],
  [383.19867397181224, 381.32574576175097],
  [494.4506243078038, 356.69138533021],
  [500.8078786127176, 390.06697043100746],
  [387.9666147004976, 409.1387333457489],
]]
plants.plant(1, 6, new Date(), geoJSONString('Polygon', polygonCoords, 30))

plants.plant(2, 10, '2020-11-02T21:49:47.846Z', geoJSONString('Point', [11282.476091303026, 6120603.438889541]))
plants.plant(2, 10, '2020-11-02T21:49:50.216Z', geoJSONString('Point', [11301.137475161711, 6120596.1236270685]))
plants.plant(2, 10, '2020-11-02T21:49:50.216Z', geoJSONString('Point', [11321.590351870831, 6120587.315453887]))
plants.plant(2, 10, '2020-11-02T21:49:50.216Z', geoJSONString('Point', [11342.34181072169, 6120578.059407493]))
const secondPolygonCoords = [[
  [11258.440228893038, 6120588.509782454],
  [11252.916459270868, 6120578.059407493],
  [11348.014871414729, 6120533.570668374],
  [11353.24005889516, 6120545.066080831],
  [11258.440228893038, 6120588.509782454],
]]
plants.plant(2, 6, new Date(), geoJSONString('Polygon', secondPolygonCoords, 30))

export default Generate('MapPlants', plants, ['load', 'add', 'delete', 'update'])
